import { jsx as _jsx } from "react/jsx-runtime";
import React, { useCallback } from "react";
import { useRouter } from "next/router";
import Link from "next/link";
import { mixpanelEvent } from "@/lib/mixpanels/mixpanel";
export function ActiveLink(param) {
    let { className , children , href , passHref , legacyBehavior , onClick  } = param;
    const router = useRouter();
    const handleClick = useCallback((e)=>{
        e.preventDefault();
        onClick === null || onClick === void 0 ? void 0 : onClick(e);
        mixpanel(href);
        router.push(href);
    }, [
        href
    ]);
    const mixpanel = (href)=>{
        switch(href){
            case "/introduce":
                return mixpanel("Introduce Clicked from Header");
            case "/protection":
                return mixpanelEvent("Protection Clicked from Header");
            case "/b2b":
                return mixpanel("B2B Clicked from Header");
            default:
                return null;
        }
    };
    const options = {};
    if (typeof children !== "string") {
        options["passHref"] = true;
        options["legacyBehavior"] = true;
    }
    return /*#__PURE__*/ _jsx(Link, {
        ...options,
        className: className,
        href: href,
        onClick: handleClick,
        passHref: passHref,
        legacyBehavior: legacyBehavior,
        children: children
    });
}
